import { useState } from 'react'
import { Modal } from '../UI/Modal/Modal'
import { Form } from 'react-bootstrap'

interface CancelSampleRequestModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: (reason: string) => void
  isSubmitting?: boolean
  requestNumber?: string
}

export function CancelSampleRequestModal({
  open,
  onOpenChange,
  onConfirm,
  isSubmitting = false,
  requestNumber,
}: CancelSampleRequestModalProps) {
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError('Cancellation reason is required')
      return
    }

    onConfirm(reason)
  }

  const handleClose = () => {
    if (!isSubmitting) {
      setReason('')
      setError('')
      onOpenChange(false)
    }
  }

  return (
    <Modal
      open={open}
      onOpenChange={(isOpen) => !isOpen && handleClose()}
      title="Cancel Sample Request"
      description={`Are you sure you want to cancel sample request${requestNumber ? ` #${requestNumber}` : ''}? This action cannot be undone.`}
      size="md"
      onAccept={handleSubmit}
      acceptButtonText={isSubmitting ? 'Cancelling...' : 'Confirm Cancellation'}
      blockAccept={isSubmitting || !reason.trim()}
      acceptButtonProps={{ variant: 'danger' }}
      onCancel={handleClose}
      cancelButtonText="Cancel"
      blockCancel={isSubmitting}
    >
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Form.Label htmlFor="cancellation-reason">
            Cancellation Reason <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            id="cancellation-reason"
            placeholder="Please provide a reason for cancelling this sample request..."
            value={reason}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              setReason(e.target.value)
              if (error) setError('')
            }}
            disabled={isSubmitting}
            isInvalid={!!error}
            rows={4}
            maxLength={1000}
          />
          {error && (
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          )}
          <Form.Text className="text-muted">
            {reason.length}/1000 characters
          </Form.Text>
        </div>
      </div>
    </Modal>
  )
}
